import { Component, ChangeDetectionStrategy, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MessageDialog } from '@shared/models/message-dialog.model';
import { ZDialogComponent } from '../z-dialog/z-dialog.component';
import { MatIcon } from '@angular/material/icon';
import { ZButtonComponent } from '../z-button/z-button.component';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-message-dialog',
    templateUrl: './message-dialog.component.html',
    styleUrls: ['./message-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ZDialogComponent, MatIcon, MatDialogTitle, ZButtonComponent, MatTooltip, TranslatePipe]
})
export class MessageDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<MessageDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MessageDialog,
  ) { }


  confirm(value: boolean) {
    this.dialogRef.close(value);
  }
}